import * as z from 'zod'

import {
  IdentityRecognitionDocumentEnum,
  IdentityRecognitionFileEnum,
} from '~/shared/config/enums'
import { ApiModel } from './core'

const attributeSchema = z.object({
  documentType: z.nativeEnum(IdentityRecognitionDocumentEnum),
  taxiparkId: z.string(),
  files: z.array(
    z.object({
      type: z.nativeEnum(IdentityRecognitionFileEnum),
      uuid: z.string(),
    }),
  ),
})

const schema = attributeSchema

export enum RecognitionStatusEnum {
  pending = 'in_progress',
  completed = 'completed',
  error = 'error',
}

export type RecognitionEntity = Record<string, string>

export type DocumentRecognitionResult = {
  entities: RecognitionEntity
  errors: string[]
}

export type RecognitionErrorsResponse = {
  'driver-license-front'?: DocumentRecognitionResult
  'driver-license-back'?: DocumentRecognitionResult
  passport?: DocumentRecognitionResult
}

export type CorrectionField = {
  documentType: 'driver-license-front' | 'driver-license-back' | 'passport'
  fieldName: string
  label: string
  currentValue?: string
}

export type IdentityRecognitionRequestAttributes = z.infer<
  typeof attributeSchema
>

export class IdentityRecognitionRequest extends ApiModel<
  typeof schema,
  IdentityRecognitionRequestAttributes
> {
  static jsonApiType = 'identity-recognition-request'

  static schema = schema

  static async sendDocumentForRecognition(
    attrs: IdentityRecognitionRequestAttributes,
  ): Promise<{ id: number; success: boolean; secretCode: string }> {
    const url = `${IdentityRecognitionRequest.getJsonApiUrl()}/store`
    const response = await IdentityRecognitionRequest.effectiveHttpClient.post(
      url,
      attrs,
    )
    return response.getData()
  }

  static async resultDocumentForRecognition(
    id: number,
    secretCode: string,
  ): Promise<{
    id: number
    status: RecognitionStatusEnum
    recognitionResult?: RecognitionErrorsResponse
  }> {
    const url = `${IdentityRecognitionRequest.getJsonApiUrl()}/result`
    const response = await IdentityRecognitionRequest.effectiveHttpClient.post(
      url,
      { id, secretCode },
    )
    return response.getData()
  }
}
